export enum ValidityState {
    InvalidDate,
    InvalidPersonalNumber,
    InvalidSsnControlCharacter,
    InvalidCompanyIdBody,
    InvalidCompanyIdControlCharacter,
    InvalidDataFormat,
    Valid,
}
